// Angular
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../core/reducers';
import { AuthService } from '../../../../provider/auth/auth.service';
import { AuthNoticeService } from '../../../../provider/auth/auth-notice.service';
import { ProductService } from 'src/app/provider/product.service';

@Component({
  selector: 'kt-login',
  templateUrl: './login.component.html',
  encapsulation: ViewEncapsulation.None
})
export class LoginComponent implements OnInit, OnDestroy {
  loginForm: FormGroup;
  loading = false;
  error = false;
  private unsubscribe: Subject<any>;
  private returnUrl: any;

  email: string;
  password: string;

  constructor(
    private router: Router,
    private auth: AuthService,
    private authNoticeService: AuthNoticeService,
    private store: Store<AppState>,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private prodServ: ProductService
  ) {
    this.unsubscribe = new Subject();
  }

  async ngOnInit() {

    if (this.route.snapshot.queryParams['tokenval']) {
      const tokenForm = {
        app_hotel_id: Number(this.route.snapshot.queryParams['apphotelid']),
        app_hotels: this.route.snapshot.queryParams['apphotels'],
        available_for_chat: Boolean(this.route.snapshot.queryParams['availableforchat']),
        cc_email_address: this.route.snapshot.queryParams['ccemailaddress'],
        department_id: Number(this.route.snapshot.queryParams['departmentid']),
        email: this.route.snapshot.queryParams['email'],
        expire: this.route.snapshot.queryParams['expire'],
        guest_visible: Boolean(this.route.snapshot.queryParams['guestvisible']),
        id: Number(this.route.snapshot.queryParams['id']),
        job_title: this.route.snapshot.queryParams['jobtitle'],
        language_code: this.route.snapshot.queryParams['languagecode'],
        last_name: this.route.snapshot.queryParams['lastname'],
        mobile_phone: this.route.snapshot.queryParams['mobilephone'],
        name: this.route.snapshot.queryParams['name'],
        role: this.route.snapshot.queryParams['role'],
        section_id: Number(this.route.snapshot.queryParams['sectionid']),
        see_all_departments_for_chat: Boolean(this.route.snapshot.queryParams['seealldepartmentsforchat']),
        token_val: this.route.snapshot.queryParams['tokenval'],
        user_status: Number(this.route.snapshot.queryParams['userstatus'])
      };


      localStorage.setItem('token_form', JSON.stringify(tokenForm));
      localStorage.setItem('hotelId', JSON.stringify(tokenForm.app_hotel_id));
      await this.prodServ.postPushMobileData(tokenForm.app_hotel_id);
      this.router.navigate(['/']);
    }

    this.auth.loginStatusChanged.subscribe((data: boolean) => {
      if (data) {
        this.router.navigateByUrl(this.returnUrl).then();
        this.error = false;
      } else {
        this.loading = false;
        this.cdr.markForCheck();
        this.error = true;
      }
    });

    this.initLoginForm();

    this.route.queryParams.subscribe(params => {
      this.returnUrl = params['returnUrl'] || '/';
    });
  }

  ngOnDestroy(): void {
    this.authNoticeService.setNotice(null);
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.loading = false;
  }

  initLoginForm() {
    this.loginForm = this.fb.group({
      email: [this.email, Validators.compose([Validators.required, Validators.email,
      Validators.minLength(3), Validators.maxLength(320)])],

      password: [this.password, Validators.compose([Validators.required, Validators.minLength(3),
      Validators.maxLength(100)])]
    });
  }

  submit() {
    const controls = this.loginForm.controls;
    /** check form */
    if (this.loginForm.invalid) {
      Object.keys(controls).forEach(controlName => controls[controlName].markAsTouched());
      return;
    }

    this.loading = true;

    const authData = {
      email: controls['email'].value,
      password: controls['password'].value
    };
    this.auth.signinUser(authData.email, authData.password);
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.loginForm.controls[controlName];
    if (!control) {
      return false;
    }

    return control.hasError(validationType) && (control.dirty || control.touched);
  }

}
